import { DeleteOutlined } from '@ant-design/icons';
import styled, { css } from 'styled-components';

import { Button } from 'components/ui';

export const StyledDeleteButtonLink = styled(Button)<{ $hoverTransparent?: boolean }>`
  color: ${({ theme }) => theme.lightRed} !important;
  &:hover,
  &:focus,
  &:active {
    color: ${({ theme }) => theme.red} !important;
    ${({ $hoverTransparent }) =>
      $hoverTransparent &&
      css`
        background: transparent !important;
      `}
  }
`;

export const StyledDeleteButton = styled(Button)<{ $isWrapped: boolean }>`
  width: ${({ $isWrapped }) => ($isWrapped ? '100%' : null)};
`;

export const StyledWarning = styled.div`
  font-size: 1.1rem;
`;

export const DisabledDeleteIcon = styled(DeleteOutlined)`
  color: ${({ theme }) => theme.disabledTextColor};
`;
